import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { LinkOutlined, FileOutlined } from "@ant-design/icons";
import "./Toolkit.scss";

const Toolkit = () => {
  const [copied, setCopied] = useState(false);

  const videoUrl = "https://cdn.metinc.tech/downloads/d4urc-2026/Drive_HowTo_0226_compressed.mp4";
  const guideUrl = "/downloads/2026EventPlanningGuideV2.pdf";

  const handleCopyVideoLink = () => {
    navigator.clipboard.writeText(videoUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDownloadGuide = () => {
    window.open(guideUrl, "_blank");
  };

  return (
    <div className="toolkit-page main-content">
      <div className="toolkit-container">
        <h1 className="toolkit-title">Event Planning</h1>
        <p className="toolkit-description">
        This section contains a video and event planning guide that provide tips to hosting a successful event.
        </p>

        <div className="toolkit-content">
          {/* How-To Video Section */}
          <div className="toolkit-section">
            <div className="video-container">
              <video controls className="how-to-video">
                <source src={videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="link-section">
              <div className="link-label">
                <LinkOutlined className="link-icon" />
                <span>How-To Video</span>
              </div>
              <Button
                className="copy-button"
                onClick={handleCopyVideoLink}
                primary={true}
              >
                {copied ? "Link Copied!" : "Click to Copy How-To Video Link to Clipboard"}
              </Button>
            </div>
          </div>

          {/* Event Planning Guide Section */}
          <div className="toolkit-section">
            <div className="guide-preview-container">
              <iframe
                src={guideUrl}
                className="guide-preview-pdf"
                title="Event Planning Guide Preview"
              />
            </div>
            <div className="link-section">
              <div className="link-label">
                <FileOutlined className="link-icon" />
                <span>Event Planning Guide</span>
              </div>
              <Button
                className="download-button"
                onClick={handleDownloadGuide}
                primary={true}
              >
                Link to Download Event Planning Guide
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toolkit;

